import { ErrorBoundary as ZenErrorBoundary } from '@zenbusiness/application-commons-logging';
import { useVisit } from '@zenbusiness/application-commons-visit';

function ShoppingErrorBoundary({ children, ...delegated }) {
  const { visitUuid } = useVisit();
  return (
    <ZenErrorBoundary context-visit={{ visitUuid }} {...delegated}>
      {children}
    </ZenErrorBoundary>
  );
}

export default ShoppingErrorBoundary;
